@if (globserv.AntragPferd==undefined) {
  <div>
    <mat-expansion-panel #panSearch class='pasuraMat1 mat-elevation-z4'  style='margin-top:20px; min-width: 800px;'  [expanded]="this.antrag==undefined">
      <mat-expansion-panel-header>
        <mat-panel-title class="flex-center" >
          Suche Anträge
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <mat-form-field class="flex-center">
          <!-- <mat-label>Volltext-Suche</mat-label> -->
          <input class="flex-center" placeholder="Volltext-Suche" matInput [(ngModel)]="SuchText"  name="Suche" type="text">
        </mat-form-field>
      </div>
      <div layout="row" >
        <mat-chip-list aria-label="Suchoptionen" [multiple]='true' style="display: block; justify-content: space-between ">
          <mat-chip-option style="margin-right:5px" (click)="toggelSuchoptionen(0)" [selected]="Suchoptionen[0]">neue</mat-chip-option>
          <mat-chip-option style="margin-right:5px" (click)="toggelSuchoptionen(1)" [selected]="Suchoptionen[1]">Einschätzung beauftragt</mat-chip-option>
          <mat-chip-option style="margin-right:5px" (click)="toggelSuchoptionen(2)" [selected]="Suchoptionen[2]">Einschätzung eingegangen</mat-chip-option>
          <mat-chip-option style="margin-right:5px" (click)="toggelSuchoptionen(3)" [selected]="Suchoptionen[3]">angenommene</mat-chip-option>
          <mat-chip-option (click)="toggelSuchoptionen(4)" [selected]="Suchoptionen[4]">abgelehnte</mat-chip-option>
        </mat-chip-list>
      </div>
      <button mat-flat-button	color="primary"(click)="sucheAntraege()" style="margin-top:10px; width: 100%">Suchen</button>
      <div>
        @if (antraege!=undefined ) {
          <mat-table  #tableAntraege [dataSource]='antraege'>
            <ng-container matColumnDef="Antrag">
              <mat-header-cell *matHeaderCellDef>Antrag</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.AntragID}} / {{element.TimeStamp}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Status">
              <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.StatusTextKurz}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Tierarzt">
              <mat-header-cell *matHeaderCellDef>Tierartz</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{element.TierarztID}} {{element.Antrag.Tierarzt.Name}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Tierhalter">
              <mat-header-cell *matHeaderCellDef>Tierhalter</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.Antrag.VN.Name}} {{element.Antrag.VN.Vorname}} {{element.Antrag.VN.Ort}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Pferd">
              <mat-header-cell *matHeaderCellDef>Pferd</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.Antrag.Pferd.Name}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row 	*matRowDef="let row; columns: displayedColumns"
              class='TabRow'
              (click)="selectAntrag(row)"
              [ngClass]="{hovered: row.hovered}"
              (mouseover)="row.hovered = true"
            (mouseout)="row.hovered = false"></mat-row>
          </mat-table>
        }
      </div>
    </mat-expansion-panel >
    @if (antrag!=undefined) {
      <mat-card class='pasuraMat1 displNormal mat-elevation-z4'  >
        <div style="min-height: 450px;">
          <mat-tab-group class='TabGroup'>
            <mat-tab label="Antrag"  >
              <div style="margin-top: 25px; margin-left: 60px; margin-right: 60px;">
                @if (antrag.Antrag.VN.PolNr !=undefined && antrag.Antrag.VN.PolNr >0) {
                  <div>
                    <mat-grid-list cols="3" rowHeight="20px"  style="width:800px ">
                      <mat-grid-tile><div class="gridContentLeft">Police:</div></mat-grid-tile>
                      <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.PolNr}}</div></mat-grid-tile>
                    </mat-grid-list>
                  </div>
                }
                @if (antrag.Antrag.VN.Nr !=undefined && antrag.Antrag.VN.Nr >0) {
                  <div>
                    <mat-grid-list cols="3" rowHeight="20px"  style="width:800px ">
                      <mat-grid-tile><div class="gridContentLeft">Adress-Nr:</div></mat-grid-tile>
                      <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.Nr}}</div></mat-grid-tile>
                    </mat-grid-list>
                  </div>
                }
                <mat-grid-list cols="3" rowHeight="20px"  style="width:800px ">
                  <mat-grid-tile><div class="gridContentLeft">Antrag-Nr:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.AntragID }}</div></mat-grid-tile>
                  <mat-grid-tile><div class="gridContentLeft">Versicherungsnehmer:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.Anrede}} {{antrag.Antrag.VN.Name}} {{antrag.Antrag.VN.Vorname}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.Strasse}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.PLZ}}, {{antrag.Antrag.VN.Ort}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.EMail}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.VN.Telefon}}</div></mat-grid-tile>
                  @if (antrag.Antrag.Files!= undefined && antrag.Antrag.Files.length >0) {
                    <div>
                      @for (anhang of antrag.Antrag.Files; track anhang) {
                        <div >
                          <mat-grid-tile>Anhang:</mat-grid-tile>
                          <mat-grid-tile colspan="2">
                            <button mat-button  style="margin-top: -10px"  (click)="getFile(anhang.ID, anhang.FileName)" >
                              <mat-icon matTooltip="{{anhang.FileName}}" >picture_as_pdf</mat-icon>
                            </button>
                          </mat-grid-tile>
                        </div>
                      }
                    </div>
                  }
                </mat-grid-list>
                @if (antrag.Antrag.VN.Nr == undefined || antrag.Antrag.VN.Nr<=0) {
                  <button mat-flat-button	color="primary"(click)="newVNKontakt()" style="width: 100%; margin-top: 10px;">Neuer Kontakt für Versicherungsnehmer erstellen</button>
                }
                @if (antrag.Antrag.VN.Nr>0 ) {
                  <button mat-flat-button	color="primary"(click)="openKontakt(antrag.Antrag.VN.Nr)" style="width: 100%; margin-top: 50px;">Versicherungsnehmer in Kontakte öffnen</button>
                }
                @if (kontakt!=undefined &&  antrag.Antrag.VN.Nr!=kontakt.Bexio.nr) {
                  <button mat-flat-button	color="primary"(click)="setVN()" style="width: 100%; margin-top: 10px;">Versicherungsnehmer {{kontakt.Bexio.nr}} {{kontakt.Bexio.name_1}} übernehmen</button>
                }
                <!--
                <button *ngIf="antrag.AntragStatus<30" mat-flat-button	color="primary"(click)="editAntrag()" style="width: 100%; margin-top: 10px;">Antrag anpassen</button>
                -->
                @if (antrag.AntragStatus==0) {
                  <button mat-flat-button	color="primary"(click)="deleteAntragAsk()" style="width: 100%; margin-top: 10px;">Antrag löschen</button>
                }
                @if (antrag.AntragStatus<=20) {
                  <button mat-flat-button	color="primary"(click)="ablehnAntragAsk()" style="width: 100%; margin-top: 10px;">Antrag ablehnen</button>
                }
              </div>
            </mat-tab>
            <mat-tab label="Pferd"  >
              <div style="margin-top: 25px; margin-left: 60px; margin-right: 60px;">
                <mat-grid-list cols="3" rowHeight="20px"  style="width:800px ">
                  <mat-grid-tile><div class="gridContentLeft">Name:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Pferd.Name}} {{antrag.Antrag.Pferd.NameZusatz}}</div></mat-grid-tile>
                  <mat-grid-tile><div class="gridContentLeft">PassChip:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Pferd.PassChip}}</div></mat-grid-tile>
                  <div *ngif="antrag.Antrag.Pferd.Rasse!=undefined && antrag.Antrag.Pferd.Rasse.lenght>0">
                    <mat-grid-tile><div class="gridContentLeft">Rasse:</div></mat-grid-tile>
                    <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Pferd.Rasse}}</div></mat-grid-tile>
                  </div>
                  <div *ngif="antrag.Antrag.Pferd.Farbe!=undefined && antrag.Antrag.Pferd.Farbe.lenght>0">
                    <mat-grid-tile><div class="gridContentLeft">Farbe:</div></mat-grid-tile>
                    <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Pferd.Farbe}}</div></mat-grid-tile>
                  </div>
                  <mat-grid-tile><div class="gridContentLeft">Geschlecht:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{globserv.getSex(antrag.Antrag.Pferd.Sex)}}</div></mat-grid-tile>
                  <mat-grid-tile><div class="gridContentLeft">Gebdat:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.PraemieCalc.getPraemie.GebDat}}</div></mat-grid-tile>
                  <mat-grid-tile><div class="gridContentLeft">Versicherungsbeginn:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.PraemieCalc.getPraemie.VBeginn}}</div></mat-grid-tile>
                  <mat-grid-tile><div class="gridContentLeft">Versicherungssumme:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{globserv.formatMoney(antrag.Antrag.PraemieCalc.getPraemie.VS)}}</div></mat-grid-tile>
                  <mat-grid-tile><div class="gridContentLeft">Zahlweise:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{globserv.getZW(antrag.Antrag.PraemieCalc.getPraemie.Zahlweise)}}</div></mat-grid-tile>
                  @for (hv of globserv.getHauptPositionen(antrag.Antrag.PraemieCalc.getPraemie); track hv) {
                    <div >
                      <mat-grid-tile><div class="gridContentLeft">{{hv.MarketingName}}</div></mat-grid-tile>
                      <mat-grid-tile colspan="2"><div class="DatenBetrag"  >{{globserv.formatMoney(hv.Netto)}}</div></mat-grid-tile>
                      @if (hv.Selbstbehalt!=undefined) {
                        <div >
                          <mat-grid-tile><div class="gridContentLeft">Selbstbehalt:</div></mat-grid-tile>
                          <mat-grid-tile colspan="2"><div class="DatenBetrag">{{globserv.formatMoney(hv.Selbstbehalt)}}</div></mat-grid-tile>
                        </div>
                      }
                    </div>
                  }
                  @for (opt of globserv.getOptionen(antrag.Antrag.PraemieCalc.getPraemie); track opt) {
                    <div >
                      <mat-grid-tile><div class="gridContentLeft">{{opt.MarketingName}}:</div></mat-grid-tile>
                      <mat-grid-tile colspan="2"><div class="DatenBetrag">{{globserv.formatMoney(opt.Netto)}}</div></mat-grid-tile>
                    </div>
                  }
                  <mat-grid-tile><div class="gridContentLeft">PraemieTotal:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="DatenBetrag"  >{{globserv.formatMoney(antrag.Antrag.PraemieCalc.getPraemie.PraemieTotal)}}</div></mat-grid-tile>
                </mat-grid-list>
              </div>
            </mat-tab>
            <mat-tab label="Tierarzt"  >
              <div style="margin-top: 25px; margin-left:  60px; margin-right: 60px;">
                @if (antrag.Antrag.Tierarzt.Nr !=undefined && antrag.Antrag.Tierarzt.Nr >0) {
                  <div>
                    <mat-grid-list cols="3" rowHeight="20px"  style="width:800px ">
                      <mat-grid-tile><div class="gridContentLeft">Adress-Nr:</div></mat-grid-tile>
                      <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.Nr}}</div></mat-grid-tile>
                    </mat-grid-list>
                  </div>
                }
                <mat-grid-list cols="3" rowHeight="20px"  style="width:800px ">
                  <mat-grid-tile><div class="gridContentLeft">Tierarzt:</div></mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.Name}}</div></mat-grid-tile>
                  @if (antrag.TierarztPersID>0 &&antrag.Antrag.Tierarzt.Person !=undefined) {
                    <div >
                      <mat-grid-tile>&nbsp;</mat-grid-tile>
                      <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.Person}}</div></mat-grid-tile>
                    </div>
                  }
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.Strasse}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.PLZ}}, {{antrag.Antrag.Tierarzt.Ort}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.EMail}}</div></mat-grid-tile>
                  <mat-grid-tile>&nbsp;</mat-grid-tile>
                  <mat-grid-tile colspan="2"><div class="gridContentLeft"  >{{antrag.Antrag.Tierarzt.Telefon}}</div></mat-grid-tile>
                  @if (kontakt!=undefined  &&  antrag.Antrag.Tierarzt.Nr==kontakt.Bexio.nr && kontakt.Personen.length>0 ) {
                    <div style="margin-top: 10px">
                      <mat-grid-tile>Tierarzt-Person</mat-grid-tile>
                      <mat-grid-tile colspan="2">
                        <div class="gridContentLeft"  >
                          <mat-select  [(ngModel)]="antrag.TierarztPersID" name="TierarztPersID"  (selectionChange)="saveTierarztPers(antrag.TierarztPersID)">
                            <mat-option  [value]='0'>Hauptadresse (wie oben)</mat-option>
                            @for (pers of kontakt.Personen; track pers) {
                              <div>
                                <mat-option  [value]='pers.PersID'>{{pers.PersName}} {{pers.PersVorname}} ({{pers.PersMail}})</mat-option>
                              </div>
                            }
                          </mat-select>
                        </div>
                      </mat-grid-tile>
                    </div>
                  }
                </mat-grid-list>
                <!--  -->
                @if (antrag.Antrag.Tierarzt.Nr>0 ) {
                  <button mat-flat-button	color="primary"(click)="globserv.setPasuraAction('loadContact;' +antrag.Antrag.Tierarzt.Nr)" style="width: 100%; margin-top: 50px;">Tierarzt in Kontakte öffnen</button>
                }
                @if (kontakt!=undefined &&  kontakt.Tierarzt && antrag.Antrag.Tierarzt.Nr!=kontakt.Bexio.nr) {
                  <button mat-flat-button	color="primary"(click)="setTierarzt()" style="width: 100%; margin-top: 10px;">Tierarzt {{kontakt.Bexio.nr}} {{kontakt.Bexio.name_1}} übernehmen</button>
                }
                @if (antrag.Antrag.Tierarzt.Nr<=0) {
                  <button mat-flat-button	color="primary"(click)="newTierarztKontakt()" style="width: 100%; margin-top: 10px;">Neuer Kontakt für Tierarzt erstellen</button>
                }
                @if (antrag.AntragStatus==0) {
                  <button [disabled]="antrag.Antrag.Tierarzt.Nr<=0 || antrag.Antrag.VN.Nr<=0 " mat-flat-button	color="primary"(click)="makeEinschaetzungsAuftragPDF()" style="width: 100%; margin-top: 50px;">Einschätzungs-Auftrag per PDF</button>
                }
                @if (antrag.Antrag.Tierarzt.EMail.length>5 && antrag.AntragStatus==0) {
                  <button [disabled]="antrag.Antrag.Tierarzt.Nr<=0 " mat-flat-button	color="primary"(click)="makeEinschaetzungsAuftragMail()" style="width: 100%; margin-top: 10px;">Einschätzungs-Auftrag per E-Mail</button>
                }
                @if (antrag.Antrag.Tierarzt.EMail.length>5 && antrag.AntragStatus>0) {
                  <button [disabled]="antrag.Antrag.Tierarzt.Nr<=0 " mat-flat-button	color="primary"(click)="resetEinschaetzungsAuftragAsk()" style="width: 100%; margin-top: 10px;">Auftrag zurücksetzen</button>
                }
                @if (showMailinfo) {
                  <div class="alert">
                    <span class="closebtn"  (click)="this.showMailinfo=false">&times;</span>
                    Der Auftrag wurde per Mail versendet!
                  </div>
                }
              </div>
            </mat-tab>
            <mat-tab label="Einschätzung" >
              <app-einschaetzung  [einschaetzung]="einschaetzung" [antrag]="antrag"  >Loading..</app-einschaetzung>
              @if (antrag!=undefined && antrag.Antrag.Tierarzt.Nr>0 && antrag.Antrag.VN.Nr>0 && i==0 ) {
                <button
                  mat-flat-button color="primary"(click)="createPolice()" style="width: 100%; margin-top: 10px;">
                  Antrag in Police überführen
                </button>
              }
              <!--
              {{globserv.policen!=undefined}}
              {{ globserv.policen[0]!=undefined && antrag.AntragStatus==20}}
              {{globserv.kontakt!=undefined }}
              {{antrag.Antrag.VN.Nr== globserv.kontakt.Bexio.nr}}
              -->
              @if (globserv.policen!=undefined && globserv.policen[0]!=undefined && antrag.AntragStatus==20 && globserv.kontakt!=undefined &&  antrag.Antrag.VN.Nr== globserv.kontakt.Bexio.nr) {
                <button
                  mat-flat-button	color="primary"(click)="uebernahmePferd(this.globserv.policen[0].PolicenNr)" style="width: 100%; margin-top: 10px;">
                  Pferd in Police {{this.globserv.policen[0].PolicenNr}} übernehmen
                </button>
              }
            </mat-tab>
          </mat-tab-group>
          <div flex layout="row">
            <md-content flex>
              @if (antrag!=undefined && antrag.Antrag.Tierarzt.Nr<=0 ) {
                <div class='InfoTextAntrag'>
                  Der Tierarzt muss noch als Kontakt erfasst werden
                </div>
              }
              @if (antrag!=undefined && antrag.AntragStatus>=20 && ( antrag.Antrag.VN.Nr==undefined || antrag.Antrag.VN.Nr<=0 )) {
                <div class='InfoTextAntrag'>
                  Der Versicherungsnehmer muss noch als Kontakt erfasst werden
                </div>
              }
            </md-content>
          </div>
        </div>
      </mat-card>
    }
  </div>
}